"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ajax = require("rxjs/ajax");

var _operators = require("rxjs/operators"); // pending update - not currently working - old version


var _default = function _default(variationId, SERVER_URL) {
  return (0, _ajax.ajax)({
    body: {
      variationId: variationId
    },
    crossDomain: true,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer ".concat(localStorage.getItem("abcloudToken"))
    },
    url: "".concat(SERVER_URL, "/open-in-editor")
  }).pipe((0, _operators.take)(1)).subscribe(function (done) {
    return console.log("open-in-editor", variationId);
  });
};

exports.default = _default;